import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
import { SeedPaths } from './Seed';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-[5/4] w-full border-b border-paper-dark object-cover object-center" data-id="element-21" data-mp="av35ut3p3515" />;
  }
  return <div aria-hidden="true" className="relative flex h-[230px] items-center justify-center border-b border-paper-dark bg-gradient-to-br from-peach-soft to-teal-soft sm:h-[265px]" data-id="element-22" data-mp="1su00gjdfzu3">
      <div className="relative aspect-[4/5] w-[46%] max-w-[190px] overflow-hidden rounded-md bg-white shadow-cover" data-id="element-23" data-mp="3o2wtbkcik9oa">
        <div className="px-[9%] pt-[12%]" data-id="element-24" data-mp="3t0yc046126z8">
          <span className="block text-[10px] font-bold text-teal-deep" data-id="element-25" data-mp="1mai37xztfyws">Bonus {bonus.number}</span>
          <span className="mt-1.5 block font-display text-[13px] font-semibold leading-tight text-navy" data-id="element-26" data-mp="1r931vszf6aj4">{bonus.title}</span>
        </div>
        <svg viewBox="-60 -60 120 120" className="absolute -bottom-6 left-1/2 h-24 w-24 -translate-x-1/2" data-id="element-27" data-mp="3id54j69013as">
          <SeedPaths data-id="element-28" data-mp="3detvuyufwyu5" />
        </svg>
        <span className={`absolute inset-x-0 bottom-0 h-[4%] ${bonus.accent}`} data-id="element-29" data-mp="3ddioyq5p7ayt" />
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-teal-soft" data-id="element-30" data-mp="3n67pwr3mh6fw">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-31" data-mp="2zf2d6kszau9t">
        <div className="text-center" data-id="element-32" data-mp="2zhf0zelf3yus">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-33" data-mp="2uh967pjupw8h">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-34" data-mp="38gs3fnb4jn60">
            Five instant-use <span className="wash-text" data-id="element-35" data-mp="33gdzohgk2zds">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-navy-soft" data-id="element-36" data-mp="npi1g5qfrkph">
            The volumes give you the year. These five get you running it this
            week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-37" data-mp="3cjfyzdkyarjg">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl bg-white shadow-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-38" data-mp="3hhhqmmwfzz6j" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-39" data-mp="2tsf2cw7az832" />
              <div className="px-5 pb-6 pt-4" data-id="element-40" data-mp="2ttgc8xcl1oj7">
                <div className="flex flex-wrap items-center gap-2" data-id="element-41" data-mp="2tqlujdkyehth">
                  <span className="text-xs font-semibold text-navy-muted" data-id="element-42" data-mp="2xujrbhmt3gjd">Bonus {bonus.number}</span>
                  <span className="rounded-full bg-peach-soft px-2.5 py-1 text-[11px] font-bold text-peach-deep" data-id="element-43" data-mp="32rk1o4qov5ga">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl font-semibold leading-snug text-navy" data-id="element-44" data-mp="2a3o28s9qizft">{bonus.title}</h3>
                <p className="mt-2 text-sm text-navy-soft" data-id="element-45" data-mp="2f1pp7oaa7iwk">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}